import axios from 'axios';

export const shopifyService = {

    /** Create, Edit Amazon Product */

    createShopifyService: (body) => axios.post(`/map`,
        {
            ...body,
            type: 'SHOPIFY',
        },
        { auth: true })
    ,

    getShopifyService: (params) => axios.get(`/map`, { auth: true, params: { ...params, type: 'SHOPIFY' } }),

    editShopifyMap: (body, id) => axios.patch(`/map/${id}`,
        {
            ...body,
            type: 'SHOPIFY',
        },
        { auth: true },
    ),

    deleteShopifyMap: (id) => axios.delete(`/map/${id}`, { auth: true, params: { type: 'SHOPIFY' } }),

    /** End */

    /**  Amazon Setup  */

    getShopifySetup: (params) => axios.get(`/shopify/setup`, { ...params, auth: true }),

    getShopifySingleSetup: (id) => axios.get(`/shopify/setup/${id}`, { auth: true }),

    editShopifySetup: (body, id) => axios.patch(`/shopify/setup/${id}`, body, { auth: true }),

    editShopifySetupStatus: (storeId, status) => axios.patch(`/shopify/setup/${storeId}/status`, { status }, {
        params: { status },
        auth: true,
    }),

    creatShopifySetup: (body) => axios.post(`/shopify/setup`, body, { auth: true }),

    /**  Shopify Orders  */

    getShopifyOrdersService: (params) => axios.get(`/shopify/orders`, { auth: true, params: params }),

    getShopifyTransverseService: (params) => axios.get(`/transfer`, {
        auth: true,
        params: { ...params, type: 'SHOPIFY' },
    }),

    syncResyncService: (params, orderId) => axios.patch(`/core/shopify/orders/${orderId}`, null, {
        auth: true,
        params: params,
    }),

    orderProductMapService: (id) => axios.get(`/map/sku/${id}`,
        {
            auth: true,
            params: {
                type: 'SHOPIFY',
            },
        },
    ),

    /** Shopify Price Rules */
    editShopifyPriceRules: (storeId, body) => axios.patch(`/shopify/setup/${storeId}/price-settings`, body, { auth: true }),
};
